import React from "react";
import {
  Typography,
  Avatar,
  Grid,
  Divider,
  Stack,
  Paper,
  Button,
  Chip,
  ThemeProvider
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import mainTheme from "../../../newComponent/themeprovider/mainTheme/MainTheme";
import { fDate } from "../../../../utils/formatTime";

const ViewSelectedAssignmentDetails = ({ rowData, onClose }) => {
  return (
    <ThemeProvider theme={mainTheme}>
      <>
        
        {/* Student Info */}
        <Grid container spacing={2} alignItems="center">
          <Grid item>
            <Avatar sx={{ width: 50, height: 50 }} />
          </Grid>

          <Grid item xs>
            <Typography fontWeight={600}>
              {rowData?.sp_user_id?.first_name} {rowData?.sp_user_id?.last_name}
            </Typography>

            <Typography variant="body2" color="text.secondary">
              {rowData?.sp_user_id?.email} ({rowData?.sp_user_id?.mobile})
            </Typography>
          </Grid>

          <Grid item>
            <Typography variant="body2">
              Submitted Date : <br />
              Max Marks :
            </Typography>
          </Grid>

          <Grid item>
            <Typography variant="body2">
              {fDate(rowData?.submitted_date)} <br />
              {rowData?.assignment_id?.max_marks}
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        {/* Assignment */}
        <Typography mb={1} variant="body2">
          <b>Assignment:</b> {rowData?.assignment_id?.title} (
          {rowData?.assignment_id?.assignment_type})
        </Typography>

        {/* Status */}
        <Stack direction="row" alignItems="center" spacing={1} mb={2}>
          <Typography variant="body2">
            <b>Status:</b>
          </Typography>

          <Chip
            label={rowData?.status}
            color={
              rowData?.status === "Pending"
                ? "warning"
                : rowData?.status === "Graded"
                ? "success"
                :rowData?.status === "Rejected" ?
                 "error"
                 :"info"
            }
            size="small"
          />
        </Stack>

        {/* Checked By */}
         <Typography mb={1} variant="body2">
          <b>Checked By:</b> {rowData?.checked_by?.first_name} {rowData?.checked_by?.last_name}
        </Typography>

        {/* Checked Date */}

        <Typography mb={1} variant="body2">
          <b>Checked Date:</b> {fDate(rowData?.checked_date)}
        </Typography>

        {/* Marks Obtained */}

        <Typography mb={1} variant="body2">
          <b>Marks Obtained:</b> {rowData?.obtained_marks}
        </Typography>

        {/* Submitted File */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography variant="body2">
            <b>Submitted File:</b>{" "}
            {rowData?.assignment_object?.original_filename}
          </Typography>

    
        

       
       


          <Button
            variant="contained"
            size="small"
            startIcon={<DownloadIcon />}
              onClick={()=>window.open(rowData?.assignment_link, "_blank")}
            sx={{
              backgroundColor: "#F3D9A4",
              color: "#000",
              textTransform: "none",
              "&:hover": { backgroundColor: "#e7c888" }
            }}
          >
            Download
          </Button>
        </Stack>

        {/* Feedback */}
        {rowData?.feedback && rowData?.status === "Graded" && (
          <>
            <Typography fontWeight={500} mb={0.5} variant="body2">
              Feedback:
            </Typography>

            <Paper
              variant="outlined"
              sx={{
                p: 1.5,
                backgroundColor: "#f9f9f9",
                fontSize: "13px",
                mb: 2
              }}
            >
              {rowData?.feedback}
            </Paper>
          </>
        )}

       

        {/* Decline Reason */}
        {rowData?.reason_for_decline && rowData?.status === "Rejected" && (
          <>
            <Typography fontWeight={500} mb={0.5} variant="body2">
              Decline Reason:
            </Typography>

            <Paper
              variant="outlined"
              sx={{
                p: 1.5,
                backgroundColor: "#fff3f3",
                fontSize: "13px",
                mb: 2
              }}
            >
              {rowData?.reason_for_decline}
            </Paper>
          </>
        )}

        {/* Footer */}
        {/* <Stack direction="row" justifyContent="flex-end">
          <Button variant="outlined" size="small" onClick={onClose}>
            Close
          </Button>
        </Stack> */}

      </>
    </ThemeProvider>
  );
};

export default ViewSelectedAssignmentDetails;
